//@flow

import type {BannerButtonEntityType} from '../../../../../../entities';

type GetBannerActionOptions = {
  identifier: string,
  type: BannerButtonEntityType,
  domain: string,
};
export function getBannerActionUrl(options: GetBannerActionOptions) {
  const {identifier, type, domain} = options;
  if (type === 'URL') {
    return identifier;
  }

  if (type === 'COLLECTION') {
    return `${domain}/collection/${identifier}`;
  }

  if (type === 'CATEGORY') {
    return `${domain}/category/${identifier}`;
  }

  if (type === 'PRODUCT') {
    return `${domain}/product/${identifier}`;
  }

  if (type === 'PROMOTION') {
    return `${domain}/promo/${identifier}`;
  }
}
